export const ACCOUNT_MAIN_MENU = [
  {
    to: 'compte',
    label: 'components.userAccountMenu.compte',
    icon: ['fal', 'user-circle'],
  },
  {
    to: 'compte-commandes',
    label: 'components.userAccountMenu.compte_commandes',
    icon: ['fal', 'check'],
  },
  {
    to: 'compte-service-client',
    label: 'components.userAccountMenu.compte_service_client',
    icon: ['fal', 'tools'],
  },
  {
    to: 'compte-retours-produits',
    label: 'components.userAccountMenu.compte_retours_produits',
    icon: ['fal', 'redo-alt'],
  },
  {
    to: 'compte-paniers-sauvegardes',
    label: 'components.userAccountMenu.compte_paniers_sauvegardes',
    icon: ['fal', 'check'],
  },
  {
    to: 'compte-alertes-disponibilite',
    label: 'components.userAccountMenu.compte_alertes_disponibilite',
    icon: ['fal', 'lightbulb-on'],
  },
  {
    to: 'compte-favoris',
    label: 'components.userAccountMenu.compte_favoris',
    icon: ['fal', 'heart'],
  },
  {
    to: 'compte-historique',
    label: 'components.userAccountMenu.compte_historique',
    icon: ['fal', 'clock'],
  },
]

export const DASHBOARD_ROUTE = 'compte'

export function accountShortcuts(menu = ACCOUNT_MAIN_MENU) {
  return menu.filter(item => item.to !== DASHBOARD_ROUTE)
}
